$(document).ready(function(){
    function expertiseSlider() {
    const $slider = $(".js-pricing-table-slider");

    if ($(window).width() <= 991) {
        if (!$slider.hasClass("slick-initialized")) {
        $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: true,
            prevArrow: '<button class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0671/4186/1516/files/slick-arrow-left.svg?v=1778665738" alt="Previous"></button>',
            nextArrow: '<button class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0671/4186/1516/files/slick-arrow-right.svg?v=1778665738" alt="Next"></button>',
            responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    initialSlide: 1
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    initialSlide: 1                
                },
            },
            ],
        });
        }
    } else {
        if ($slider.hasClass("slick-initialized")) {
        $slider.slick("unslick");
        }
    }
    }

    expertiseSlider();

    $(window).on("resize", function () {
        expertiseSlider();
    });

    
    if ($(".js-testimonials-slider").length > 0) {
      $(".js-testimonials-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: false,
        autoplay: false,
        autoplaySpeed: 2000,
        // responsive: [
        //   {
        //     breakpoint: 1024,
        //     settings: {
        //       slidesToShow: 1.1,
        //     },
        //   },
        //   {
        //     breakpoint: 992,
        //     settings: {
        //       slidesToShow: 1.8,
        //     },
        //   },
        //   {
        //     breakpoint: 767,
        //     settings: {
        //       slidesToShow: 1,
        //       infinite: true
        //     },
        //   }
        // ],
      });
    }
});